import { chainsMetadata } from "../constants/chainsMetadata";

export const getSupportedChainIds = () =>
  chainsMetadata.map(({ chainId }) => chainId);
